import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import * as Sentry from '@sentry/angular';

if (environment.production) {
  enableProdMode();
}

// Sentry carries errors only. Browser tracing sampled 30% of sessions and,
// through the sentry-trace header it propagated to the API, made every backend
// on the request path keep its own spans as well. Traces belong in Honeycomb:
// no browserTracingIntegration, no tracesSampleRate.
Sentry.init({
  dsn: environment.sentryDsn,
  release: `${environment.name}@${environment.version}`,
  environment: environment.production ? 'production' : 'staging',
  beforeSend: (e) => {
    if (shouldSkipByError(e)) return null;

    return e;
  },
});

const bootstrap = () =>
  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((err) => console.error(err));

bootstrap().catch((err) => console.log('Main.tx', err));

const errors = [
  'auth/invalid-credential',
  'https://storage.googleapis.com/documents.closecare.com.br',
];

const shouldSkipByError = (e: Sentry.ErrorEvent) =>
  e?.exception?.values?.some((error) =>
    errors.some((errorName) => error?.value?.includes(errorName))
  );
